export default __webpack_public_path__ + "static/media/fast.b82a9e37.svg";